import { Moon, Sun } from "lucide-react";
import { THEMES, THEME_HEADING, THEME_SCOPE_NOTE, themeLabel, themeNote, normalizeTheme } from "../theme.js";

// ITEM 6 — **THE ONE CONTROL THAT CHOOSES A THEME.** In My Room's settings, where her order puts it.
//
// Hookless on purpose (R7/R8's entry requirement): props in, tree out, so `scripts/lr15-themes.mjs`
// CALLS it once per theme and reads the tree back rather than regexing the JSX for a class name. The
// state and the writing live in `MyRoomPage`, which already owns `room_state` and already persists
// it — a second writer for one key is a second answer to "what is saved".
//
// It is a ROSTER WALK, never two hand-written buttons: `THEMES` is the list, so a third theme is one
// entry in `src/theme.js` and this control grows a chip by existing. Both chips are always rendered
// and one is `aria-pressed` — a single toggle button that says "Light" tells you what it WILL do,
// never what is on, and a member who cannot see which is chosen taps it to find out.
export function ThemeChoice({ theme, onChoose }: { theme: string; onChoose: (theme: string) => void }) {
  const current = normalizeTheme(theme);
  return (
    <div className="theme-choice">
      <h3 className="theme-choice__head">{THEME_HEADING}</h3>
      <p className="theme-choice__note">{THEME_SCOPE_NOTE}</p>
      <div className="theme-choice__row">
        {THEMES.map((t) => (
          <button
            key={t}
            type="button"
            className={t === current ? `theme-chip theme-chip--${t} is-on` : `theme-chip theme-chip--${t}`}
            onClick={() => onChoose(t)}
            aria-pressed={t === current}
          >
            <span className="theme-chip__swatch" aria-hidden="true">{t === "light" ? <Sun size={15} /> : <Moon size={15} />}</span>
            <span className="theme-chip__body">
              <strong>{themeLabel(t)}</strong>
              <em>{themeNote(t)}</em>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
